/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown>, requestId: NonNullable<unknown> }} Error_With_Request_IdInputs */

const en_error_with_request_id = /** @type {(inputs: Error_With_Request_IdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.message} (request ${i?.requestId})`)
};

/**
* | output |
* | --- |
* | "{message} (request {requestId})" |
*
* @param {Error_With_Request_IdInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_with_request_id = /** @type {((inputs: Error_With_Request_IdInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_With_Request_IdInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_with_request_id(inputs)
});